import script from "./goRinSyo0069.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0069.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0069.vue?vue&type=style&index=0&id=5bfbacd9&lang=scss"

const __exports__ = script;

export default __exports__